import { localGetItem } from './Services/CacheProviderService';

export const LINE_ITEM_REMARKS_MAX_LENGTH = 250;

/** Truncates line-item remark text for UI and API payloads. */
export function clampLineItemRemarks(str) {
    if (str == null || str === '') return '';
    const s = String(str);
    return s.length <= LINE_ITEM_REMARKS_MAX_LENGTH
        ? s
        : s.slice(0, LINE_ITEM_REMARKS_MAX_LENGTH);
}

/**
 * Prefer `enable_line_item_remarks` in localStorage (updated by Custom Config save and
 * GetCustomConfig in Muidrawer) over `loggedInUserInfo`, so toggling the setting hides
 * UI immediately without requiring re-login.
 */
export function isLineItemRemarksEnabled() {
    const ls = localGetItem('enable_line_item_remarks');
    if (ls !== null && ls !== '') {
        const lower = String(ls).toLowerCase();
        if (lower === 'true' || lower === '1') return true;
        if (lower === 'false' || lower === '0') return false;
    }
    try {
        const raw = localGetItem('loggedInUserInfo');
        if (raw) {
            const u = JSON.parse(raw);
            return u?.enable_line_item_remarks === true;
        }
    } catch (e) {
        /* ignore */
    }
    return false;
}

export function isMandatoryConcessionRemarksEnabled() {
    const ls = localGetItem('mandatory_individual_concession_remarks');
    if (ls !== null && ls !== '') {
        const lower = String(ls).toLowerCase();
        if (lower === 'true' || lower === '1') return true;
        if (lower === 'false' || lower === '0') return false;
    }
    try {
        const raw = localGetItem('loggedInUserInfo');
        if (raw) {
            const u = JSON.parse(raw);
            return u?.mandatory_individual_concession_remarks === true;
        }
    } catch (e) {
        /* ignore */
    }
    return false;
}
